import { BaseAction } from "../../../core/actions/BaseAction";
import { IBookingResponse } from "../../../Orchestrator/Types/Types/BookingTypes";

export class ShareTicketAction extends BaseAction<void, { bookingDetails: IBookingResponse }> {

    override async run(): Promise<void> {
        try {
            const { bookingDetails } = this.params!;
            if (navigator.share) {
                await navigator.share({
                  title: "Ticket Details",
                  text: `Booking Reference: ${bookingDetails?.booking?.bookingCode}`,
                  url: window.location.href,
                });
              }
        } catch (error) {
            console.error("Error in ShareTicketAction:", error);
        }
    }
}

// Create a singleton instance
export const shareTicketAction = new ShareTicketAction(); 